<template>
    <TransitionRoot
    appear
    :show="show"
    enter="duration-300 ease-out"
    enter-from="opacity-0"
    enter-to="opacity-100"
    leave="duration-200 ease-in"
    leave-from="opacity-100"
    leave-to="opacity-0">
        <Dialog :open="show" class="fixed inset-0 z-[995] overflow-y-auto">
            <div class="h-full fixed right-0 top-0 overflow-y-scroll">
                <TransitionChild
                    enter="duration-300 ease-out"
                    enter-from="opacity-0"
                    enter-to="opacity-100"
                    leave="duration-200 ease-in"
                    leave-from="opacity-100"
                    leave-to="opacity-0">
                    <DialogOverlay class="fixed inset-0 bg-black opacity-30" @click="$emit('close')" />
                </TransitionChild>

                <TransitionChild
                    enter="duration-300 ease-out"
                    enter-from="w-0"
                    enter-to="w-[36rem]"
                    leave="duration-200 ease-in"
                    leave-from="w-[36rem]"
                    leave-to="w-0">
                    <div class="relative min-h-screen w-[36rem] bg-[#f8fafc] relative">
                        <svg @click="$emit('close')" v-if="!disableCloseButton" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 hover:cursor-pointer absolute right-[15px] top-[15px] text-gray" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                        <slot></slot>
                    </div>
                </TransitionChild>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script>
    import { ref } from 'vue';
    import {
        TransitionRoot,
        TransitionChild,
        Dialog,
        DialogOverlay,
    } from '@headlessui/vue';

    export default {
        components: { TransitionRoot, TransitionChild, Dialog, DialogOverlay },
        props: {
            show: { type: Boolean, default: false },
            disableCloseButton: { type: Boolean, default: false },
        }
    };
</script>
